// @ts-strict-ignore
import {Component, Injector, OnInit} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {OperatorChecklist, Permissions, Scenario, TrainingSession} from "@models";
import {Router} from "@angular/router";
import {SimChecklistService, SimUserExtendedService} from "@services";
import {AssessablePanelMode} from "@common/components/assessment/utils";

export interface DialogData_ScenarioInformationDialogInput extends MatDialogDataBaseInput {
	scenario: Scenario;
	trainingSession?: TrainingSession;
	sessionRunIndex?: number;
}

export interface DialogData_ScenarioInformationDialogOutput extends MatDialogDataBaseOutput {}

@Component({
	selector: "sim-scenario-information-dialog",
	templateUrl: "./scenario-information-dialog.component.html",
	styleUrls: ["./scenario-information-dialog.component.scss"],
	standalone: false,
})
export class ScenarioInformationDialogComponent
	extends BasicMaterialDialog<
		ScenarioInformationDialogComponent,
		DialogData_ScenarioInformationDialogInput,
		DialogData_ScenarioInformationDialogOutput
	>
	implements OnInit
{
	protected readonly AssessablePanelMode = AssessablePanelMode;
	checklists: OperatorChecklist[] = [];
	permissionScenarioAccessAll: boolean = false;

	constructor(
		_injector: Injector,
		private _router: Router,
		private _simChecklistService: SimChecklistService,
		private _simUserService: SimUserExtendedService,
	) {
		super(_injector);
		this.permissionScenarioAccessAll = this._simUserService.hasPermission(Permissions.Scenario_Access);
	}

	async ngOnInit() {
		super.ngOnInit();
		if (!this.data.trainingSession || this.data.sessionRunIndex === undefined) {
			return;
		}
		const scenarioRecordingsMap = this.data.trainingSession.scenarioRecordingGroups[
			this.data.sessionRunIndex
		].scenarioRecordingsMap.find((srm) => srm.scenarioId === this.data.scenario.id);
		this.checklists = await this._simChecklistService.getOperatorChecklistsByIds(scenarioRecordingsMap.operatorChecklistIds);
	}

	openInAdmin() {
		this.close({action: "ok"});
		if (this.permissionScenarioAccessAll) {
			this._router.navigate([`web-manager/list/scenario-editor/edit/${this.data.scenario.id}`]);
		}
	}
}
